module.exports = __webpack_public_path__ + "images/495ae5c7226eaed2e023f7faba752ed8.svg";